module.exports = __webpack_public_path__ + "static/media/colegio-monte-tabor.a69b5a6a.jpg";